import * as React from "react";
import { forwardRef } from "react";
const SvgAdd2 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 29, height: 29, viewBox: "0 0 29 29", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.1421 5.89258V22.3917M5.89256 14.1422H22.3917", stroke: "#222222", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgAdd2);
export default ForwardRef;
